import Glide from "@glidejs/glide";

if (document.querySelector(".glide")) {
  const glide = new Glide(".glide", {
    type: "carousel",
    keyboard: false,
    autoplay: 15000,
    hoverpause: true,
    animationDuration: 1500,
  });

  glide.mount();

  // Update glide value after modal closed. **If not, glide gets initial width value and slides shift to the right**.
  const legalInfoButton = document.querySelector(".v_button__cookie");
  if (legalInfoButton) {
    legalInfoButton.addEventListener("click", () =>
      // TODO: way to detect when modal is fully closed, replace setTimeout with that event.
      setTimeout(() => glide.update(), 300),
    );
  }
}
